// extracted by mini-css-extract-plugin
module.exports = {"mobilePhoneNumberInputBox":"style_mobilePhoneNumberInputBox__1UX9V","mobilePhoneNumberCheckMark":"style_mobilePhoneNumberCheckMark__3GAIr","largeInput":"style_largeInput__1ACHg"};